import {useMutation, useQueryClient} from '@tanstack/react-query'

import {createCompany, updateCompany} from './api'
import {companyKeys} from './keys'
import {CompanyRequest} from './types'

export const useCreateCompany = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createCompany,
    onSuccess: () => queryClient.invalidateQueries({queryKey: companyKeys.lists()}),
  })
}

export const useUpdateCompany = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({id, body}: {id: string; body: CompanyRequest}) => updateCompany(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: companyKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: companyKeys.lists()})
    },
  })
}
